import { ReactNode } from "react";
import { ThemeProvider, createTheme, responsiveFontSizes } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { createTeamTheme } from "@/global/theme";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";

interface Props {
  children: ReactNode;
}

export function AppThemeProvider({ children }: Props) {
  const teamConfig = useTeamConfig();

  if (!teamConfig) return null;

  let theme = createTeamTheme(teamConfig);
  theme = responsiveFontSizes(theme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
